import React from 'react';
import { Button } from '@/components/ui/button';
import { Lock } from 'lucide-react';

export default function InitiatePaymentStep({ finalTotal, processing, onInitiate }) {
  return (
    <div className="space-y-4">
      <div className="bg-blue-50 border border-blue-200 p-4 rounded-2xl flex items-start gap-3">
        <Lock className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
        <div>
          <p className="text-sm font-bold text-blue-900 mb-1">Secure Payment via Pocket Pay</p>
          <p className="text-xs text-blue-700">
            Your payment is processed securely through Pocket Pay gateway.
            Currency: BND (Brunei Dollar).
          </p>
        </div>
      </div>

      {/* No Refund Policy - Informational */}
      <div className="bg-muted/30 border border-border p-3 rounded-xl">
        <p className="text-xs text-muted-foreground text-center leading-relaxed">
          <strong className="text-foreground">No Refund Policy: </strong>Payments are non-refundable and cannot be canceled once processed.
          No-show bookings may be rescheduled, subject to court availability and management approval.
          <br />By using SmashZone, you agree to our Terms &amp; Conditions.<br />

        </p>
      </div>

      <Button
        onClick={onInitiate}
        disabled={processing}
        className="btn-volt w-full h-14 text-lg font-black"
        data-testid="initiate-payment-button"
      >
        {processing ? 'Initiating Payment...' : `Proceed to Payment - $${finalTotal.toFixed(2)}`}
      </Button>
    </div>
  );
}
